import { render, staticRenderFns } from "./loginRight.vue?vue&type=template&id=04661d48&scoped=true"
import script from "./loginRight.vue?vue&type=script&lang=ts"
export * from "./loginRight.vue?vue&type=script&lang=ts"
import style0 from "./loginRight.vue?vue&type=style&index=0&id=04661d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04661d48",
  null
  
)

export default component.exports